import { useContext } from "react";

import { PurchaseOrderContext } from "../context/PurchaseOrderContext";

export const usePurchaseOrderContext = () => {
  const context = useContext(PurchaseOrderContext);

  return context;
};
